import { sprintf } from 'sprintf-js';

class Sprintf {
  install(Vue) {
    Vue.prototype.$sprintf = sprintf;
  }
}

export default new Sprintf();
